export const MISSION_PALETTE: Record<string, { bg: string; border: string; text: string }> = {
  purple: { bg: '#EEEDFE', border: '#AFA9EC', text: '#3C3489' },
  teal:   { bg: '#E1F5EE', border: '#5DCAA5', text: '#085041' },
  blue:   { bg: '#E6F1FB', border: '#85B7EB', text: '#0C447C' },
  pink:   { bg: '#FBEAF0', border: '#ED93B1', text: '#72243E' },
  amber:  { bg: '#FAEEDA', border: '#EF9F27', text: '#633806' },
  coral:  { bg: '#FAECE7', border: '#F0997B', text: '#712B13' },
  gray:   { bg: '#F1EFE8', border: '#B4B2A9', text: '#444441' },
  green:  { bg: '#EAF3DE', border: '#97C459', text: '#27500A' },
  red:    { bg: '#FCEBEB', border: '#F09595', text: '#791F1F' },
};

export const PALETTE_KEYS = Object.keys(MISSION_PALETTE) as Array<keyof typeof MISSION_PALETTE>;

export const PALETTE_LABELS: Record<string, string> = {
  purple: 'Violet',
  teal:   'Sarcelle',
  blue:   'Bleu',
  pink:   'Rose',
  amber:  'Ambre',
  coral:  'Corail',
  gray:   'Gris',
  green:  'Vert',
  red:    'Rouge',
};
